module.exports = __webpack_public_path__ + "media/inflammatory adenoma.63419085.wav";